const uuid = () => Math.round(Math.random() * 46656 || 0);

export default uuid;
